import React from "react";
import { Popup } from "../../../Types";
import { getLanguageFile } from "../../common/GetLanguageFile";

function OpenTextPopup({
  popup,
  setOpen,
}: {
  popup: Popup;
  setOpen: (bool: boolean) => void;
}) {
  return (
    <div
      style={{
        minWidth: "10rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h3>{popup.title}</h3>
        <button onClick={() => setOpen(false)} id="popup-close">
          {getLanguageFile("generics.close")}
        </button>
      </div>
      <p style={{}}>{popup.text}</p>
    </div>
  );
}

export default OpenTextPopup;
